exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.staff-card[data-v-14edc016] {\n    max-width: 30rem;\n}\n", ""]);

// exports
